import React from 'react';
import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { DropIndicator } from '../DropIndicator';
import { resolveDropIndicatorLabel } from '../../domain/dnd/drop-labels';
import type { DropData } from '../../domain/dnd/types';
import { selectDocumentSections } from '../../domain/selectors';
import { useEditorStore } from '../../domain/store';
import {
  useActiveDropData,
  useCollisionRect,
  useEditorDragItem,
} from './drop-slot-registry';

const layerStyle: CSSProperties = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 10001,
};

function usesLineDropIndicator(data: DropData): boolean {
  return data.kind !== 'block-slot' || data.zone !== 'fill';
}

export function DropFeedbackLayer() {
  const { t } = useTranslation();
  const sections = useEditorStore(selectDocumentSections);
  const dragItem = useEditorDragItem();
  const collisionRect = useCollisionRect();
  const activeDropData = useActiveDropData();

  if (
    dragItem == null ||
    collisionRect == null ||
    activeDropData == null ||
    !usesLineDropIndicator(activeDropData)
  ) {
    return null;
  }

  return (
    <div
      className="email-builder-drop-feedback-layer"
      style={{
        ...layerStyle,
        left: collisionRect.left,
        top: collisionRect.top,
        width: collisionRect.width,
        height: collisionRect.height,
      }}
    >
      <DropIndicator
        label={resolveDropIndicatorLabel(dragItem, activeDropData, sections, t)}
      />
    </div>
  );
}
